export interface ComputeCanSendArgs {
  /** ChatInput props.disableSend；access 未初始化时由父组件先关闭发送。 */
  disableSend: boolean;
  /** ChatInput props.sending；外部 stream/网络发送中。 */
  sending: boolean;
  /** 内部状态：草稿附件正在上传。 */
  uploadingFile: boolean;
  /** entitled→ready 自动 flush 期间，禁止用户再次手动触发发送。 */
  flushingBufferedDraft: boolean;
  /** 已 trim 后的输入文本。 */
  messageContent: string;
  /** 当前草稿附件数量 > 0。 */
  hasAttachments: boolean;
}

/**
 * 决定 send 按钮是否可点：
 * - 任一禁用条件命中 → false；
 * - 否则要求至少有文本或附件之一。
 */
export const computeCanSend = ({
  disableSend,
  sending,
  uploadingFile,
  flushingBufferedDraft,
  messageContent,
  hasAttachments,
}: ComputeCanSendArgs): boolean => {
  if (disableSend || sending || uploadingFile || flushingBufferedDraft) return false;
  return !!messageContent || hasAttachments;
};
